export const QuizAdapter = (questions, answers, results) => {
  const resultset = {}
  questions.map(q => {
    const key = `${q.question}${q.position}`
    resultset[key] = { title: q.question }
    answers
      .filter(a => a.parent === q.question)
      .map(a => {
        resultset[key] = {
          ...resultset[key],
          answers: {
            ...resultset[key].answers,
            [`${a.answer}${a.position}`]: {
              title: a.answer,
              image: a.image.full,
              result: results.items
                .filter(n => n.title === a.nextresult)
                .map(n => `${n.title}`)[0],
              next: questions
                .filter(n => n.question === a.nextquestion)
                .map(n => `${n.question}${n.position}`)[0]
            }
          }
        }
      })
  })
  console.log(resultset)

  return resultset
}



// WEBPACK FOOTER //
// ./src/js/quiz/adapters/quiz.adapter.js